import { __assign, __rest } from "tslib";
import React from 'react';
import VeltTextCommentToolbarCommentAnnotation from './VeltTextCommentToolbarCommentAnnotation/VeltTextCommentToolbarCommentAnnotation';
import VeltTextCommentToolbarCopywriter from './VeltTextCommentToolbarCopywriter/VeltTextCommentToolbarCopywriter';
import VeltTextCommentToolbarGeneric from './VeltTextCommentToolbarGeneric/VeltTextCommentToolbarGeneric';
import VeltTextCommentToolbarDivider from './VeltTextCommentToolbarDivider/VeltTextCommentToolbarDivider';
import { transformWireframeProps } from '../../utils/propUtils';
var VeltTextCommentToolbar = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-text-comment-toolbar-wireframe", __assign({}, transformedProps), children));
};
VeltTextCommentToolbar.CommentAnnotation = VeltTextCommentToolbarCommentAnnotation;
VeltTextCommentToolbar.Copywriter = VeltTextCommentToolbarCopywriter;
VeltTextCommentToolbar.Generic = VeltTextCommentToolbarGeneric;
VeltTextCommentToolbar.Divider = VeltTextCommentToolbarDivider;
export default VeltTextCommentToolbar;
